// Card copy rounds up to five minutes so a displayed time is never shorter
// than the real one
export const formatDuration = (minutes?: number | null): string | null => {
  if (!minutes || minutes <= 0) return null

  const rounded = Math.ceil(minutes / 5) * 5
  const hours = Math.floor(rounded / 60)
  const remainder = rounded % 60

  const parts = []
  if (hours > 0) parts.push(`${hours}h`)
  if (remainder > 0) parts.push(`${remainder}m`)

  return parts.join(' ')
}

const formatDriveTime = (minutes?: number | null): string | null => {
  const duration = formatDuration(minutes)

  return duration && `${duration} drive`
}

export default formatDriveTime
